import { createSlice } from "@reduxjs/toolkit";

export const HistoryPageSlice = createSlice({
    name:"HistoryPage",
    initialState:{
        page:0,
        dropDown:0,
        pageNameList:[],
        pageName:"",
        pageActive:[true, false, false, false, false],
        // dropDownActive:[true, false, false]
        dropDownActive:[true, false]
    },
    reducers:{
        SET_PAGENAME:(state, action)=>{
            if(action.payload!==null){ 
                state.pageNameList = action.payload.pageNameList
                state.pageName = action.payload.pageNameList[action.payload.index]
            }
        },
        SET_PAGE:(state, action)=>{
            if(action.payload!==null){
                state.page = action.payload
                state.pageActive = [false, false, false, false, false]
                state.pageActive[action.payload] = true
                state.dropDown = 0
                // state.dropDownActive = [true, false, false]
                state.dropDownActive = [true, false]
                state.pageName = state.pageNameList[action.payload]
            }
        },
        SET_DROPDOWN:(state, action)=>{
            if(action.payload!==null){
                state.dropDown = action.payload
                state.dropDownActive = [false, false, false]
                state.dropDownActive = [false, false]
                state.dropDownActive[action.payload] = true
            }
        },
        
    },

})

export const {
    SET_PAGENAME,
    SET_PAGE,
    SET_DROPDOWN
} = HistoryPageSlice.actions

export default HistoryPageSlice.reducer